import React from "react";
import { Chip } from "@heroui/chip";
import classNames from "classnames";

export function Tag({
  children,
  className,
  icon,
}: {
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}) {
  return (
    <Chip
      title={
        children.toString() === "DRI" ? "Directly Responsible Individual" : ""
      }
      className={classNames({ className }, "text-xs capitalize sm:text-sm")}
      variant="flat"
      radius="sm"
      startContent={icon}
    >
      {children}
    </Chip>
  );
}
